import CustomModal from "../CustomModal";
import { useState } from "react";

function CreateLocationModal({ isOpen, onRequestClose, onSave }) {
  const [form, setForm] = useState({ name: "", address: "", phone: "" });
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    await onSave(form);
    setSaving(false);
    setForm({ name: "", address: "", phone: "" });
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="add-admin-modal"
      hideFooter={true}
    >
      <div className="form-container">
        <div className="inner-form">
          <div className="add-staff-head">
            <h2>Add Location</h2>
          </div>
          <div className="form-input" style={{padding:'0'}}>
            <form onSubmit={handleSubmit} >
              <div style={{padding:'20px'}}>
              <label htmlFor="name">Name</label>
              <input id="name" name="name" value={form.name} onChange={handleChange} required />

              <label htmlFor="address">Address</label>
              <input id="address" name="address" value={form.address} onChange={handleChange} required />

              <label htmlFor="phone">Phone</label>
              <input id="phone" name="phone" value={form.phone} onChange={handleChange} required />
              </div>

              <div className="modal-button">
                <button type="button" onClick={onRequestClose}>Cancel</button>
                <button type="submit" style={{ backgroundColor: "#0473BD", color: "white" }} disabled={saving}>
                  {saving ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </CustomModal>
  );
}

export default CreateLocationModal;
